import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { DialogStyles } from "./Dialog.styles";
import { DialogProps } from '.';
import Slide from '@material-ui/core/Slide';
import { TransitionProps } from '@material-ui/core/transitions';

const Transition = React.forwardRef(function Transition(
	props: TransitionProps & { children?: React.ReactElement<any, any> },
	ref: React.Ref<unknown>,
) {
	return <Slide direction="up" ref={ref} {...props} />;
});

const DialogView = ({ open, handleClose, title, content, onLeftArrowClick, isComponent,component, onRightArrowClick }: DialogProps) => {

	const classes = DialogStyles();
	function DynamicHTML(content: string) {
		return <span dangerouslySetInnerHTML={{ __html: content }} />;
	}
	return (
		<div className={classes.dialog}>
			<Dialog
				open={open}
				onClose={handleClose}
				classes={{
					paper: classes.dialogPaper,
					paperScrollPaper: classes.dialogpaperScrollPaper,
					paperScrollBody: classes.dialogPaperScrollBody,
				}}
				TransitionComponent={Transition}
				keepMounted
			>
				<DialogTitle disableTypography={false} classes={{ root: classes.dialogroot }}>
					<div className={classes.dialogTitle}>
						{DynamicHTML(title)}
					</div>
				</DialogTitle>
				<DialogContent classes={{ root: classes.dialogCnt }}>
					<DialogContentText classes={{ root: classes.dialogContent }}>
						{content && DynamicHTML(content)}
						
					</DialogContentText>
					{isComponent && component}
				</DialogContent>
				<DialogActions classes={{ root: classes.dialogActions }}>
					<Button onClick={handleClose} style={{color:'#0b9a64'}}>
						{"CLOSE"}
					</Button>
				</DialogActions>
			</Dialog>
		</div>
	);
}

export default DialogView